export const HYTERA = {
  id: "hytera",
  name: "HYTERA",
  imageFolder: "/hytera",
  tagline: {
    pt: "Rádio de Comunicação Profissional DMR, TETRA e PoC para Operações Críticas.",
    en: "Professional Communication Radios — DMR, TETRA and PoC for Mission-Critical Operations.",
    es: "Radio de Comunicación Profesional DMR, TETRA y PoC para Operaciones Críticas.",
  },
  color: "#0284c7",
  theme: {
    bgGradient: "from-[#e4f1fb] via-[#d8e8f5] to-[#eaf4fb]",
    blob1: "bg-sky-300/30",
    blob2: "bg-cyan-200/40",
    overlineText: "text-sky-700",
    pillarPill: "border-sky-400 text-sky-700",
    segmentHover: "hover:border-sky-400",
    tabHover: "hover:border-sky-400 hover:text-sky-700",
    ctaPrimary:
      "bg-sky-600 hover:bg-sky-700 shadow-sky-600/25 hover:shadow-sky-600/40",
    ctaOutline: "border-sky-400 text-sky-700 hover:bg-sky-50",
    productHover: "hover:border-sky-400",
    productQuoteCta: "border-sky-400 text-sky-700 hover:bg-sky-50",
    productBadge: "text-sky-700",
    productPreviewPill: "text-sky-700",
    whyPanel: "border-sky-200 from-sky-50 to-white",
    whyItemBorder: "border-sky-100",
    whyCheck: "text-sky-600",
    modalHeaderBg: "from-sky-50 via-[#d8e8f5] to-cyan-50",
    modalBrandBadge: "border-sky-200 text-sky-700",
    modalInputFocus: "focus:border-sky-500 focus:ring-sky-500/20",
    modalSubmit:
      "bg-sky-600 hover:bg-sky-700 shadow-sky-600/25 hover:shadow-sky-600/40",
  },
  pillars: {
    pt: ["DMR", "TETRA", "PoC / LTE"],
    en: ["DMR", "TETRA", "PoC / LTE"],
    es: ["DMR", "TETRA", "PoC / LTE"],
  },
  segments: {
    pt: [
      { name: "Segurança Pública", desc: "Voz crítica com segurança e interoperabilidade para operações policiais e bombeiros." },
      { name: "Transporte", desc: "Coordenação de frotas, despacho e comunicação contínua em operações de transporte." },
      { name: "Utilities", desc: "Redes dedicadas para concessionárias de energia, água e serviços essenciais." },
      { name: "Mineração", desc: "Rádios robustos e certificados para comunicação subterrânea e ambientes extremos." },
      { name: "Petróleo & Gás", desc: "Soluções intrinsecamente seguras (ATEX) para áreas explosivas." },
      { name: "Grandes Eventos", desc: "Comunicação instantânea de staff e produção em grandes recintos." },
      { name: "Segurança Privada", desc: "Rádios portáteis, bodycams e monitorização para equipas de vigilância." },
    ],
    en: [
      { name: "Public Safety", desc: "Critical voice with security and interoperability for police and fire operations." },
      { name: "Transportation", desc: "Fleet coordination, dispatch and non-stop communication across transport ops." },
      { name: "Utilities", desc: "Dedicated networks for power, water and essential-service operators." },
      { name: "Mining", desc: "Rugged, certified radios for underground communication and extreme environments." },
      { name: "Oil & Gas", desc: "Intrinsically safe (ATEX) solutions for hazardous explosive areas." },
      { name: "Large Events", desc: "Instant staff and production communication in major venues." },
      { name: "Private Security", desc: "Portable radios, bodycams and monitoring for security teams." },
    ],
    es: [
      { name: "Seguridad Pública", desc: "Voz crítica con seguridad e interoperabilidad para policía y bomberos." },
      { name: "Transporte", desc: "Coordinación de flotas, despacho y comunicación continua en operaciones de transporte." },
      { name: "Utilities", desc: "Redes dedicadas para concesionarias de energía, agua y servicios esenciales." },
      { name: "Minería", desc: "Radios robustos y certificados para entornos extremos y subterráneos." },
      { name: "Petróleo y Gas", desc: "Soluciones intrínsecamente seguras (ATEX) para áreas explosivas." },
      { name: "Grandes Eventos", desc: "Comunicación instantánea de staff y producción en grandes recintos." },
      { name: "Seguridad Privada", desc: "Radios portátiles, bodycams y monitoreo para equipos de vigilancia." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher a Hytera?",
      items: [
        "Portfólio completo DMR, TETRA e PoC/LTE",
        "Rádios robustos certificados para ambientes exigentes",
        "Modelos intrinsecamente seguros (ATEX) disponíveis",
        "BodyCams com transmissão em tempo real",
        "Infraestrutura escalável (repetidores e trunking)",
        "Assistência técnica e instalação em Angola",
      ],
    },
    en: {
      title: "Why choose Hytera?",
      items: [
        "Complete DMR, TETRA and PoC/LTE portfolio",
        "Rugged radios certified for demanding environments",
        "Intrinsically-safe (ATEX) models available",
        "BodyCams with real-time streaming",
        "Scalable infrastructure (repeaters and trunking)",
        "Local technical support and installation in Angola",
      ],
    },
    es: {
      title: "¿Por qué elegir Hytera?",
      items: [
        "Portafolio completo DMR, TETRA y PoC/LTE",
        "Radios robustos certificados para entornos exigentes",
        "Modelos intrínsecamente seguros (ATEX) disponibles",
        "BodyCams con transmisión en tiempo real",
        "Infraestructura escalable (repetidores y trunking)",
        "Soporte técnico e instalación en Angola",
      ],
    },
  },
  groups: [
    {
      id: "hp-series",
      icon: "headphones",
      featured: true,
      title: {
        pt: "Série H / HP — Rádios DMR Portáteis",
        en: "H / HP Series — DMR Portable Radios",
        es: "Serie H / HP — Radios DMR Portátiles",
      },
      description: {
        pt: "A nova geração de rádios DMR portáteis Hytera: voz clara, cobertura ampla e resistência máxima para os ambientes mais exigentes.",
        en: "The new generation of Hytera DMR portable radios: clear voice, wide coverage and maximum durability for the most demanding environments.",
        es: "La nueva generación de radios DMR portátiles Hytera: voz clara, amplia cobertura y máxima resistencia para los entornos más exigentes.",
      },
      products: [
        {
          slug: "hp682",
          pt: "HP682 — Rádio DMR portátil premium com ecrã a cores e teclado completo",
          en: "HP682 — Premium DMR portable with color display and full keypad",
          es: "HP682 — Radio DMR portátil premium con pantalla a color y teclado completo",
        },
        {
          slug: "hp562",
          pt: "HP562 — Rádio DMR portátil de gama média com ecrã monocromático",
          en: "HP562 — Mid-range DMR portable with monochrome display",
          es: "HP562 — Radio DMR portátil gama media con pantalla monocromática",
        },
        {
          slug: "hp502",
          pt: "HP502 — Rádio DMR portátil robusto, sem ecrã, simples e acessível",
          en: "HP502 — Rugged displayless DMR portable, simple and affordable",
          es: "HP502 — Radio DMR portátil robusto, sin pantalla, simple y accesible",
        },
        {
          slug: "bp565",
          pt: "BP565 — Rádio DMR portátil compacto para comunicação empresarial",
          en: "BP565 — Compact DMR portable for business communication",
          es: "BP565 — Radio DMR portátil compacto para comunicación empresarial",
        },
      ],
    },
    {
      id: "dmr-mobile",
      icon: "truck",
      title: {
        pt: "Rádios DMR Móveis",
        en: "DMR Mobile Radios",
        es: "Radios DMR Móviles",
      },
      description: {
        pt: "Rádios DMR móveis para viaturas — eficiência e produtividade em frotas, com opções de ecrã numérico ou alfanumérico.",
        en: "In-vehicle DMR mobile radios — efficiency and productivity across fleets, with numeric or alphanumeric display options.",
        es: "Radios DMR móviles para vehículos — eficiencia y productividad en flotas, con opciones de pantalla numérica o alfanumérica.",
      },
      products: [
        {
          slug: "hm652",
          pt: "HM652 — Rádio DMR móvel compacto com ecrã numérico",
          en: "HM652 — Compact DMR mobile with numeric display",
          es: "HM652 — Radio DMR móvil compacto con pantalla numérica",
        },
        {
          slug: "hm685",
          pt: "HM685 — Rádio DMR móvel premium com ecrã alfanumérico a cores",
          en: "HM685 — Premium DMR mobile with alphanumeric color display",
          es: "HM685 — Radio DMR móvil premium con pantalla alfanumérica a color",
        },
      ],
    },
    {
      id: "tetra",
      icon: "shield-alert",
      title: {
        pt: "TETRA — Rádios & Sistemas",
        en: "TETRA — Radios & Systems",
        es: "TETRA — Radios y Sistemas",
      },
      description: {
        pt: "Rádios e infraestrutura TETRA com certificação ETSI — máxima disponibilidade, segurança e interoperabilidade para missão crítica.",
        en: "ETSI-certified TETRA radios and infrastructure — maximum availability, security and interoperability for mission-critical use.",
        es: "Radios e infraestructura TETRA con certificación ETSI — máxima disponibilidad, seguridad e interoperabilidad para misión crítica.",
      },
      products: [
        {
          slug: "pt590",
          pt: "PT590 — Rádio TETRA portátil para missão crítica",
          en: "PT590 — Mission-critical TETRA portable radio",
          es: "PT590 — Radio TETRA portátil para misión crítica",
        },
        {
          slug: "mt680-plus",
          pt: "MT680 Plus — Estação base TETRA para infraestrutura trunked",
          en: "MT680 Plus — TETRA base station for trunked infrastructure",
          es: "MT680 Plus — Estación base TETRA para infraestructura trunked",
        },
      ],
    },
    {
      id: "poc",
      icon: "network",
      title: {
        pt: "PoC — Push-to-Talk sobre LTE",
        en: "PoC — Push-to-Talk over LTE",
        es: "PoC — Push-to-Talk sobre LTE",
      },
      description: {
        pt: "Dispositivos 3G/4G/5G e Wi-Fi para comunicação profissional de voz, dados e vídeo — botão PTT, GPS e plataforma de gestão inteligente.",
        en: "3G/4G/5G and Wi-Fi devices for professional voice, data and video — PTT button, GPS and intelligent management platform.",
        es: "Dispositivos 3G/4G/5G y Wi-Fi para comunicación profesional de voz, datos y video — botón PTT, GPS y plataforma de gestión inteligente.",
      },
      products: [
        {
          slug: "p50-pro",
          pt: "P50 Pro — Rádio PoC inteligente com ecrã tátil e conectividade LTE",
          en: "P50 Pro — Smart PoC radio with touchscreen and LTE connectivity",
          es: "P50 Pro — Radio PoC inteligente con pantalla táctil y conectividad LTE",
        },
        {
          slug: "pnc380",
          pt: "PNC380 — Rádio PoC compacto para comunicação diária",
          en: "PNC380 — Compact PoC radio for day-to-day communication",
          es: "PNC380 — Radio PoC compacto para comunicación diaria",
        },
        {
          slug: "pnc560",
          pt: "PNC560 — Rádio multimodo DMR + PoC, conectividade sempre",
          en: "PNC560 — Dual-mode DMR + PoC radio, always connected",
          es: "PNC560 — Radio multimodo DMR + PoC, siempre conectado",
        },
      ],
    },
    {
      id: "repeaters",
      icon: "antenna",
      title: {
        pt: "Repetidores DMR",
        en: "DMR Repeaters",
        es: "Repetidores DMR",
      },
      description: {
        pt: "Estações repetidoras digitais DMR que ampliam a cobertura do seu sistema de rádio — da nova geração HR106X a modelos de alta potência (RD98XS-100W) para cenários exigentes.",
        en: "DMR digital repeater stations that extend your radio system coverage — from the next-generation HR106X to high-power models (RD98XS-100W) for demanding scenarios.",
        es: "Estaciones repetidoras digitales DMR que amplían la cobertura de tu sistema — desde la nueva generación HR106X hasta modelos de alta potencia (RD98XS-100W).",
      },
      products: [
        {
          slug: "hr1066",
          pt: "HR1066 — Nova geração HR106X, repetidor DMR profissional com gestão avançada",
          en: "HR1066 — Next-generation HR106X professional DMR repeater with advanced management",
          es: "HR1066 — Nueva generación HR106X, repetidor DMR profesional con gestión avanzada",
        },
        {
          slug: "hr1065",
          pt: "HR1065 — Repetidor DMR rack-mount profissional, fiável e silencioso",
          en: "HR1065 — Reliable and quiet professional rack-mount DMR repeater",
          es: "HR1065 — Repetidor DMR profesional rack-mount, fiable y silencioso",
        },
        {
          slug: "rd98x",
          pt: "RD98X — Repetidor digital profissional para redes corporativas",
          en: "RD98X — Professional digital repeater for enterprise networks",
          es: "RD98X — Repetidor digital profesional para redes corporativas",
        },
        {
          slug: "rd98xs",
          pt: "RD98XS — Repetidor DMR com display frontal e controlos integrados",
          en: "RD98XS — DMR repeater with front display and integrated controls",
          es: "RD98XS — Repetidor DMR con pantalla frontal y controles integrados",
        },
        {
          slug: "rd98xs-100w",
          pt: "RD98XS-100W — Repetidor DMR de 100 W para coberturas extensas",
          en: "RD98XS-100W — 100 W DMR repeater for extended coverage",
          es: "RD98XS-100W — Repetidor DMR de 100 W para coberturas amplias",
        },
        {
          slug: "rd625",
          pt: "RD625 — Repetidor DMR compacto para instalações médias",
          en: "RD625 — Compact DMR repeater for mid-size sites",
          es: "RD625 — Repetidor DMR compacto para instalaciones medianas",
        },
      ],
    },
    {
      id: "dmr-systems",
      icon: "network",
      title: {
        pt: "Sistemas DMR — Trunking & Simulcast",
        en: "DMR Systems — Trunking & Simulcast",
        es: "Sistemas DMR — Trunking y Simulcast",
      },
      description: {
        pt: "Infraestrutura DMR escalável baseada em IP: troncalização digital (DS-6210 / DS-6211), estação base (DS-6250), simulcast (DS-6310), amplificação (DS-9300) e soluções XPT / Smart Dispatch para grandes operações.",
        en: "IP-based scalable DMR infrastructure: digital trunking (DS-6210 / DS-6211), base station (DS-6250), simulcast (DS-6310), bi-directional amplifier (DS-9300) and XPT / Smart Dispatch solutions for large operations.",
        es: "Infraestructura DMR escalable basada en IP: troncalización digital (DS-6210 / DS-6211), estación base (DS-6250), simulcast (DS-6310), amplificación (DS-9300) y soluciones XPT / Smart Dispatch.",
      },
      products: [
        {
          slug: "ds-6210",
          pt: "DS-6210 — Sistema DMR Trunking Digital Pro para grandes frotas",
          en: "DS-6210 — Digital DMR Trunking Pro system for large fleets",
          es: "DS-6210 — Sistema DMR Trunking Digital Pro para grandes flotas",
        },
        {
          slug: "ds-6211",
          pt: "DS-6211 — Sistema DMR Trunking Lite para operações de média dimensão",
          en: "DS-6211 — DMR Trunking Lite system for mid-size operations",
          es: "DS-6211 — Sistema DMR Trunking Lite para operaciones medianas",
        },
        {
          slug: "ds-6250",
          pt: "DS-6250 — Estação base DMR Trunking compacta de nova geração",
          en: "DS-6250 — Compact next-generation DMR Trunking base station",
          es: "DS-6250 — Estación base DMR Trunking compacta de nueva generación",
        },
        {
          slug: "ds-6310",
          pt: "DS-6310 — Sistema DMR Simulcast para cobertura sincronizada multi-sítio",
          en: "DS-6310 — DMR Simulcast system for synchronized multi-site coverage",
          es: "DS-6310 — Sistema DMR Simulcast para cobertura sincronizada multi-sitio",
        },
        {
          slug: "ds-9300",
          pt: "DS-9300 — Amplificador bidirecional para reforço de sinal DMR",
          en: "DS-9300 — Bi-directional amplifier for DMR signal boost",
          es: "DS-9300 — Amplificador bidireccional para refuerzo de señal DMR",
        },
        {
          slug: "xpt",
          pt: "XPT — Digital Trunking DMR sem controladoras dedicadas",
          en: "XPT — DMR digital trunking without dedicated controllers",
          es: "XPT — Trunking digital DMR sin controladoras dedicadas",
        },
        {
          slug: "smart-dispatch-plus",
          pt: "Smart Dispatch Plus — Software de despacho e gestão de frota em tempo real",
          en: "Smart Dispatch Plus — Real-time dispatch and fleet management software",
          es: "Smart Dispatch Plus — Software de despacho y gestión de flota en tiempo real",
        },
      ],
    },
    {
      id: "bodycams",
      icon: "camera",
      title: {
        pt: "BodyCams",
        en: "BodyCams",
        es: "BodyCams",
      },
      description: {
        pt: "Câmaras corporais profissionais com vídeo e transmissão em tempo real, elevados padrões de segurança e software à prova de adulteração.",
        en: "Professional body-worn cameras with real-time video streaming, high security standards and tamper-proof software.",
        es: "Cámaras corporales profesionales con video y transmisión en tiempo real, altos estándares de seguridad y software a prueba de manipulación.",
      },
      products: [
        {
          slug: "sc780",
          pt: "SC780 — BodyCam profissional com gravação HD e streaming",
          en: "SC780 — Professional BodyCam with HD recording and streaming",
          es: "SC780 — BodyCam profesional con grabación HD y streaming",
        },
        {
          slug: "vmm780",
          pt: "VMM780 — BodyCam multi-função para equipas de segurança",
          en: "VMM780 — Multi-function BodyCam for security teams",
          es: "VMM780 — BodyCam multifunción para equipos de seguridad",
        },
      ],
    },
    {
      id: "intrinsically-safe",
      icon: "shield",
      title: {
        pt: "Rádios Intrinsecamente Seguros",
        en: "Intrinsically Safe Radios",
        es: "Radios Intrínsecamente Seguros",
      },
      description: {
        pt: "Rádios com certificação ATEX para ambientes explosivos — petroquímica, óleo e gás, mineração e indústria química.",
        en: "ATEX-certified radios for explosive environments — petrochemical, oil & gas, mining and chemical industries.",
        es: "Radios con certificación ATEX para entornos explosivos — petroquímica, petróleo y gas, minería e industria química.",
      },
      products: [
        {
          slug: "hp785ex",
          pt: "HP785Ex — Rádio DMR portátil ATEX para zonas explosivas",
          en: "HP785Ex — ATEX DMR portable for explosive areas",
          es: "HP785Ex — Radio DMR portátil ATEX para zonas explosivas",
        },
      ],
    },
    {
      id: "accessories",
      icon: "phone",
      title: {
        pt: "Acessórios",
        en: "Accessories",
        es: "Accesorios",
      },
      description: {
        pt: "Acessórios originais Hytera: antenas, baterias, carregadores, microfones de mão, auriculares, kits automotivos e presilhas.",
        en: "Original Hytera accessories: antennas, batteries, chargers, remote speaker microphones, earpieces, car kits and clips.",
        es: "Accesorios originales Hytera: antenas, baterías, cargadores, micrófonos de mano, auriculares, kits automotrices y clips.",
      },
      products: [
        {
          slug: "antennas-audio",
          pt: "Antenas, microfones & auriculares profissionais",
          en: "Professional antennas, microphones & earpieces",
          es: "Antenas, micrófonos y auriculares profesionales",
        },
        {
          slug: "charger-battery",
          pt: "Carregadores & baterias originais",
          en: "Original chargers & batteries",
          es: "Cargadores y baterías originales",
        },
      ],
    },
  ],
};
